/* Smazání uložených odpovědí API z Cache Storage prohlížeče.
 *
 * PROČ (kontrola soukromí grafů týmu, 15. 10. 2026): service worker
 * (public/service-worker.js) ukládá každou úspěšnou GET odpověď /api/* do
 * cache „bpu-api-<verze>“ jako zálohu pro výpadek sítě — tedy i klienty,
 * analýzy a manažerské přehledy (PII). Klíčem je jen URL, ne přihlášený
 * účet, a odhlášení cache nemazalo. Na sdíleném počítači by další přihlášený
 * poradce bez sítě dostal data předchozího.
 *
 * Mažeme přímo z okna (Cache Storage je sdílená se service workerem stejného
 * původu), takže to funguje i když service worker zrovna neběží. Statické
 * soubory appky (bpu-static-*, bpu-runtime-*) zůstávají. */

export const PREDPONA_API_CACHE = "bpu-api-";

export async function smazatApiCache(uloziste = typeof caches !== "undefined" ? caches : null) {
  if (!uloziste || typeof uloziste.keys !== "function") return 0;
  try {
    const klice = await uloziste.keys();
    const api = klice.filter((k) => typeof k === "string" && k.startsWith(PREDPONA_API_CACHE));
    await Promise.all(api.map((k) => uloziste.delete(k)));
    return api.length;
  } catch {
    return 0;
  }
}
